import { injectLocal } from '@vueuse/core';
import { PRODUCT_TOP_LEVEL_CATEGORY_FLAGS_REPOSITORY } from '~/modules/product/constants/providers';

export const useTopLevelCategoryFlags = () => {
  const data = injectLocal(PRODUCT_TOP_LEVEL_CATEGORY_FLAGS_REPOSITORY);

  if (typeof data === 'undefined') {
    throw new TypeError('useTopLevelCategoryFlags() is called without provider.');
  }

  return data;
};
